<template>
  <div>
    <div id="content" class="content animated slideInRight delay-1s">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Exportar Cidades</div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="card-body">
                  <form
                    :action="$store.state.url + 'export/cities/'"
                    id="export"
                  >
                    <div class="block text-right">
                      <button class="btn btn-add" type="submit">
                        Exportar em Excel <i class="fas fa-file-export ml-2"></i>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
  mounted: function () {},
  components: {},
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Exportation/Cities.vue